<template lang="pug">
v-container(theme='light')
  v-card(flat, light)
    v-row
        v-spacer
        v-col.text-center
            .text-h3 InfoBak
        v-spacer
    v-row
        v-spacer
        v-col.flex-shrink-1.flex-grow-0
            v-img(src='icons8-upload-to-cloud-150.png', height='150', width='150')
        v-spacer
    template(v-if='hasInfoBak')
        v-row
            v-col.text-center
                p Your InfoScan system is currently being backed up securely on the Dorsett Controls Cloud. Your backups are avaialable should you need to restore through the InfoScan system.
    template(v-else)
        .d-flex
            v-spacer
            v-card(light, max-width='750', flat)
                .text-center
                    v-row
                        v-col
                            .productDescription
                                p.title {{productDescription}}
                    v-row
                        v-col
                            .productUseCase
                                p {{productUseCase}}
                    template(v-if='existingRequest && !hasInfoBak')
                        v-row
                            v-col
                                p.font-weight-bold A request has been made to activate this feature on your server on {{existingRequestDate}}
                        v-row
                            v-col
                                p The following contact information was provided for the request:
                                ul.text-left
                                    li {{existingRequest.customersSubscriptionRequest.name}}
                                    li {{existingRequest.customersSubscriptionRequest.phoneNumber}}
                                    li {{existingRequest.customersSubscriptionRequest.email}}
                                p If the information is incorrect, please contact sales.
                    template(v-else)
                        v-row
                            v-spacer
                            v-col(v-for='tier in price', :key='tier.tier')
                                v-card.brand.lighten-2(dark)
                                    v-card-title
                                        v-icon.mr-2(:class='tier.tier') cloud
                                        span {{tier.tier}}
                                    v-card-text
                                        
                                        p Up to {{tier.limit}} GB of storage
                                        p.font-weight-bold ${{tier.price}}/Month
                            v-spacer
                        v-row
                            v-col
                                p.text-caption You will automatically move up levels once your storage exceeds the cap.
                        v-row
                            v-col
                                RequestForm(serviceName='InfoBak', @done='getRequests')
            v-spacer
</template>
<script>

const PRODUCT_DESCRIPTION = `
    InfoBak is a comprehensive, secure cloud backup tool for your InfoScan system, automatically storing system configuration
    data and all point data on a daily and monthly rolling basis. Specific use cases and product features are detailed below...
`;
const PRODUCT_USE_CASE = `
    Your SCADA system has operated reliably for years - until one day you notice discrepancies in monthly data reports submitted
    to the state. Upon investigation, you find that critical flow meter parameters were unintentionally modified, and original
    values are unknown. The problem widens when you realize your last system backup is many months old. Restoring it would mean
    losing recent historical data and critical configuration updates, potentially putting you at risk of non-compliance and
    operational setbacks. This is a stressful scenario we've seen far too often among our customers. That's why we created InfoBak - 
    a simple, automated backup solution that ensures you always have a recent, reliable restore point for InfoScan. No guesswork. 
    No gaps. Just dependable disaster recovery and peace of mind.
`;
const PRICE = [
    {
        tier: 'Bronze',
        limit: 50,
        price: 50
    },
    {
        tier: 'Silver',
        limit: 100,
        price: 100
    },
    {
        tier: 'Gold',
        limit: 150,
        price: 150
    }
];

import RequestForm from './RequestForm.vue';

export default {
    components: {
        RequestForm
    },
    data () {
        return {
            productDescription: PRODUCT_DESCRIPTION,
            productUseCase: PRODUCT_USE_CASE,
            price: PRICE,
            existingRequest: null,
            existingRequestDate: null
        };
    },
    computed: {
        customerId (){
            return this.$store.state.customerId;
        },
        customer () {
            return this.$store.state.customerData;
        },
        customerName () {
            return this.$store.state.customerData?.name;
        },
        customerConfig () {
            return this.$store.state.customerData?.customersConfig;
        },
        hasInfoBak () {
            return this.customerConfig?.doCloudBackup;
        }
    },
    methods: {
        async getRequests () {
            this.existingRequest = null;
            try {
                const results = await this.get('getRequestsForCustomer', {
                    customerId: this.customerId
                });
                if (results?.length) {
                    const existingRequest = results.find(r => r.customersSubscriptionRequest?.type === 'InfoBak');
                    if (existingRequest) {
                        this.existingRequest = existingRequest;
                        const dateRequested = new Date(existingRequest.createdAt);
                        this.existingRequestDate = `${dateRequested.toLocaleDateString()} at ${dateRequested.toLocaleTimeString()}`;
                    }
                }
            } catch (err) {
                this.message = 'Something went wrong. Please try again. If the problem persists, contact Dorsett Customer Support';
                console.error(err);
            }
        }
    },
    watch: {
        customerId:{
            handler (newVal) {
                if (newVal){
                    this.getRequests();
                }
            },
            immediate: true
        },
    }
};
</script>
<style lang='scss'>
.Gold {
  background: linear-gradient(45deg,  rgba(242,215,12,1) 0%,rgba(255,255,255,1) 56%,rgba(252,235,0,1) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block; 
}
.Silver {
  background: linear-gradient(45deg,  rgba(181,181,181,1) 0%,rgba(252,252,252,1) 56%,rgba(232,232,232,1) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block; 
}
.Bronze {
  background: linear-gradient(45deg,  rgba(223,182,103,1) 0%,rgba(249,243,232,1) 56%,rgba(231,192,116,1) 96%); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block; 
}
</style>